export default __webpack_public_path__ + "static/media/insights-splash-desktop.27ca2d79.png";